import styled from 'styled-components';

const Wrapper = styled.div`
  margin-left: 11px;
  width: 149px;
`;
Wrapper.displayName = 'Wrapper';

export default Wrapper;
